module.exports = __webpack_public_path__ + "img/thunder.12513e46.svg";